<template>
  <!--
      作者 gmshop
      时间：2020-06-09
      描述：云仓-云仓管理
  -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input v-model="formInline.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="昵称或手机">
          <el-input v-model="formInline.nickName" placeholder="请输入昵称或手机"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="addClick()" type="success" icon="el-icon-plus" v-auth="'/warehouse/warehouse/add'">添加</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="user_id" label="用户ID" width="70"></el-table-column>
          <el-table-column prop="user" label="微信头像" width="80">
            <template slot-scope="scope">
              <img v-img-url="scope.row.avatarUrl" width="60" height="60" />
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="微信昵称"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column prop="product" label="云仓产品种类"></el-table-column>
          <el-table-column prop="product_number" label="云仓产品总数	"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="detail(scope.row)" type="text" size="small">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Add v-if="open_add" :open_add="open_add" :model="model" @closeDialog="closeDialogFunc($event, 'add')"></Add>

  </div>
</template>

<script>
  import WarehouseApi from '@/api/warehouse.js';
  import Add from './dialog/Add.vue';
  export default {
    components: {
      /*编辑组件*/
      Add,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        model: [],
        /*是否打开添加弹窗*/
        open_add: false,
        /*横向表单数据模型*/
        formInline: {
          user_id: '',
          nickName: '',
        },
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();

    },
    methods: {

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = self.formInline;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        // console.log(Params);
        WarehouseApi.getWarehouseList(Params, true)
        .then(res => {
         self.tableData = res.data.detail.data;
         self.totalDataNumber = res.data.detail.total;
         self.loading = false;
        })
        .catch(error => {
        });
      },

      /*打开添加*/
      detail(row) {
        let self = this;
        let params = row.user_id;
        self.$router.push({
          path: '/warehouse/warehouse/detail',
          query: {
            user_id: params,
            nickName: row.nickName
          }
        });
      },

      /*打开添加*/
      addClick() {
        this.model.excludeIds = [];
        this.model.user_id = '';
        this.open_add = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'add') {
          this.open_add = e.openDialog;
          if (e.type == 'success') {
            this.getTableList();
          }
        }
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.formInline;
        self.getTableList();
      },
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/warehouse/warehouse/index.vue